import { useEffect } from "react";
import Badge from "@/atoms/Badge";
import Tile from "@/components/molecules/Tile";
import { NoMatchIcon } from "@/atoms/Icons";
import Para from "@/atoms/text/Para";
import Button from "@/atoms/Button";

export default function IntegrationCards({ onReset, filterId, filterValue }) {
  const badge = <Badge className="align-left">Popular</Badge>;
  const tileData = [
    {
      logo: {
        fileName: "autotask-logo",
      },
      title: "Autotask",
      content: "Create and traige IT tickets as soon as customers report.",
      href: "#",
      categoryId: "all service-desk",
    },
    {
      logo: {
        fileName: "constantcontact-logo",
      },
      title: "Constant Contact",
      content: "Create email campaigns based on call & chat data.",
      href: "#",
      categoryId: "all business popular",
      badge,
    },
    {
      logo: {
        fileName: "connectwise-logo",
      },
      title: "ConnectWise",
      content: "Automatically update contacts with call and chat summaries.",
      href: "#",
      categoryId: "all customer-service",
    },
    {
      logo: {
        fileName: "encircle-logo",
      },
      title: "Encircle",
      content: "Create new property claims and notes on claims from calls.",
      href: "/integrations/encircle",
      categoryId: "all field-service popular",
      badge,
    },
    {
      logo: {
        fileName: "fieldpulse-logo",
      },
      title: "FieldPulse",
      content: "Create new leads from calls and chats.",
      href: "/integrations/fieldpulse",
      categoryId: "all field-service popular",
      badge,
    },
    {
      logo: {
        fileName: "freshdesk-logo",
      },
      title: "FreshDesk",
      content: "Automatically add call and chat data to your contacts.",
      href: "#",
      categoryId: "all customer-service",
    },
    {
      logo: {
        fileName: "franconnect-logo",
      },
      title: "FranConnect",
      content: "Manage your leads by syncing your data.",
      href: "#",
      categoryId: "all crm",
    },
    {
      logo: {
        fileName: "freshsales-logo",
      },
      title: "Freshsales",
      content: "Automate your sales process with ease.",
      href: "#",
      categoryId: "all crm",
    },
    {
      logo: {
        fileName: "googlecalendar-logo",
      },
      title: "Google Calendar",
      content: "Schedule meetings straight into your calendar.",
      href: "#",
      categoryId: "all business",
    },
    {
      logo: {
        fileName: "googleanalytics-logo",
      },
      title: "Google Analytics",
      content: "Feed data from calls and chats directly into analytics.",
      href: "#",
      categoryId: "all business",
    },
    {
      logo: {
        fileName: "googlevoice-logo",
      },
      title: "Google Voice",
      content: "Enable a seamless customer experience.",
      href: "#",
      categoryId: "all business",
    },
    {
      logo: {
        fileName: "hubspot-logo",
      },
      title: "HubSpot",
      content:
        "Build a solid inbound strategy, underpinned by call & chat data.",
      href: "#",
      categoryId: "all crm popular",
      badge,
    },
    {
      logo: {
        fileName: "housecallpro-logo",
      },
      title: "HousecallPro",
      content: "Automatically create a customer or job on your Housecall Pro.",
      href: "/integrations/housecallpro",
      categoryId: "all home-service popular",
      badge,
    },
    {
      logo: {
        fileName: "improveit-logo",
      },
      title: "Improveit 360",
      content: "Automatically add call and chat data to your contacts.",
      href: "#",
      categoryId: "all home-service popular",
      badge,
    },
    {
      logo: {
        fileName: "keap-logo",
      },
      title: "Keap",
      content: "Add call and chat data to your CRM.",
      href: "#",
      categoryId: "all business",
    },
    {
      logo: {
        fileName: "jobber-logo",
      },
      title: "Jobber",
      content: "Instantly add call and chat data to your jobs.",
      href: "/integrations/jobber",
      categoryId: "all field-service popular",
      badge,
    },
    {
      logo: {
        fileName: "insightly-logo",
      },
      title: "Insightly",
      content: "Send call and chat data straight to your CRM.",
      href: "#",
      categoryId: "all crm",
    },
    {
      logo: {
        fileName: "mailchimp-logo",
      },
      title: "Mailchimp",
      content: "Add call and chat data to your CRM.",
      href: "#",
      categoryId: "all business popular",
      badge,
    },
    {
      logo: {
        fileName: "clio-logo",
      },
      title: "Clio",
      content: "Call and chat data added automatically to your contacts.",
      href: "#",
      categoryId: "all crm",
    },
    {
      logo: {
        fileName: "microsoftteams-logo",
      },
      title: "Microsoft Teams",
      content: "Messages from AnswerForce into your chats and channels.",
      href: "#",
      categoryId: "all business popular",
      badge,
    },
    {
      logo: {
        fileName: "pipedrive-logo",
      },
      title: "Pipedrive",
      content: "Manage leads and customer data from calls and chats.",
      href: "#",
      categoryId: "all crm popular",
      badge,
    },
    {
      logo: {
        fileName: "odoo-logo",
      },
      title: "Odoo",
      content: "Create new leads with call and chat data.",
      href: "#",
      categoryId: "all crm",
    },
    {
      logo: {
        fileName: "podio-logo",
      },
      title: "Podio",
      content: "Map call and chat data to your contacts.",
      href: "#",
      categoryId: "all crm",
    },
    {
      logo: {
        fileName: "quickbooks-logo",
      },
      title: "Quickbooks",
      content: "Send customer, job, and sales information to your Quickbooks.",
      href: "/integrations/quickbooks",
      categoryId: "all business popular",
      badge,
    },
    {
      logo: {
        fileName: "radius-logo",
      },
      title: "Radius",
      content: "Run and grow Mathnasium centers with ease",
      href: "#",
      categoryId: "all crm",
    },
    {
      logo: {
        fileName: "salesforce-logo",
      },
      title: "Salesforce",
      content: "Call and chat data straight into your Salesforce CRM.",
      href: "/integrations/salesforce",
      categoryId: "all crm popular",
      badge,
    },
    {
      logo: {
        fileName: "serviceminder-logo",
      },
      title: "ServiceMinder",
      content: "Update contacts with call and chat summaries.",
      href: "#",
      categoryId: "all field-service popular",
      badge,
    },
    {
      logo: {
        fileName: "servicenow-logo",
      },
      title: "ServiceNow",
      content: "Create new calendar tasks automatically.",
      href: "#",
      categoryId: "all field-service",
    },
    {
      logo: {
        fileName: "servicetitan-logo",
      },
      title: "ServiceTitan",
      content: "Call and chat data added easily to your contacts.",
      href: "/integrations/servicetitan",
      categoryId: "all field-service popular",
      badge,
    },
    {
      logo: {
        fileName: "setmore-logo",
      },
      title: "Setmore",
      content:
        "Schedule estimates, call outs, and other appointments instantly.",
      href: "#",
      categoryId: "all scheduling",
    },
    {
      logo: {
        fileName: "servicetrade-logo",
      },
      title: "ServiceTrade",
      content: "Call and chat summaries automatically added to locations.",
      href: "#",
      categoryId: "all field-service",
    },
    {
      logo: {
        fileName: "slack-logo",
      },
      title: "Slack",
      content:
        "Collaborate with your team based on incoming call and chat data.",
      href: "#",
      categoryId: "all business popular",
      badge,
    },
    {
      logo: {
        fileName: "trello-logo",
      },
      title: "Trello",
      content: "Organize your work with ease. Add cards with call details",
      href: "#",
      categoryId: "all business",
    },
    {
      logo: {
        fileName: "thryv-logo",
      },
      title: "Thryv",
      content: "Automate your workflow with call and chat summaries.",
      href: "#",
      categoryId: "all home-service popular",
      badge,
    },
    {
      logo: {
        fileName: "webhooks-logo",
      },
      title: "Webhooks",
      content: "Create custom triggers & events to automate communications.",
      href: "#",
      categoryId: "all business",
    },
    {
      logo: {
        fileName: "zendesk-logo",
      },
      title: "Zendesk",
      content: "Run a smooth help desk based on real-time call and chat data.",
      href: "#",
      categoryId: "all customer-service popular",
      badge,
    },
    {
      logo: {
        fileName: "workiz-logo",
      },
      title: "Workiz",
      content: "Add call and chat summaries to your jobs.",
      href: "/integrations/workiz",
      categoryId: "all field-service popular",
      badge,
    },
    {
      logo: {
        fileName: "zoho-logo",
      },
      title: "Zoho CRM",
      content:
        "Act on leads faster when you integrate data from calls & chats.",
      href: "#",
      categoryId: "all crm popular",
      badge,
    },
    {
      logo: {
        fileName: "zapier-logo",
      },
      title: "Zapier",
      content: "Automate your work across 5,000 apps.",
      href: "/integrations/zapier",
      categoryId: "all business",
    },
  ];

  const showAllIntegrationHandler = (e) => {
    e.preventDefault();
    onReset("all");
  };

  const searchTile = () => {
    if (filterValue !== "") {
      const result = tileData.filter((tile) =>
        tile.title.toLowerCase().includes(filterValue.toLowerCase())
      );
      return result;
    }
  };

  const resultArray = filterValue !== "" ? searchTile() : tileData;

  return (
    <ul className="tile-wrapper w-100 fx-d fx--w to-top">
      {resultArray.length !== 0 ? (
        resultArray.map(
          (tile, idx) =>
            (resultArray === tileData
              ? tile.categoryId.includes(filterId)
              : tile) && (
              <li
                key={idx}
                className={`${tile.categoryId} ${
                  idx === resultArray.length - 1 ? "" : "mb-5 mb-reset-d"
                }`}
              >
                <Tile
                  logo={tile.logo}
                  title={tile.title}
                  badge={filterId === "popular" ? null : tile?.badge}
                  content={tile.content}
                  href={tile.href}
                  onClick={
                    tile.href === "#" ? (e) => e.preventDefault() : undefined
                  }
                />
              </li>
            )
        )
      ) : (
        <li className="m-center ta-center">
          <NoMatchIcon className="mb-2" />
          <Para desktopSize="lg" mobileSize="lg" className="bold mb-1 sec-font">
            No matching apps!
          </Para>
          <Para mobileSize="md" className="mb-5">
            We couldn't find any results matching your request.
          </Para>
          <Button
            href="#"
            size={null}
            className="text--md"
            variant="link"
            onClick={showAllIntegrationHandler}
          >
            See all integration
          </Button>
        </li>
      )}
      <style jsx>{`
        .tile-wrapper {
          gap: 28px;
        }
        @media (max-width: 1200px) {
          .tile-wrapper li {
            max-width: 335px;
            margin-left: auto;
            margin-right: auto;
          }
        }
      `}</style>
    </ul>
  );
}
